<template>
  <div class="hero" :class="[ fullpage ? 'fullpage' : '' ]" :style="{ opacity }">
    <split-text>
      <h1 slot-scope="{}" ref="text" v-html="msg"></h1>
    </split-text>

    <div class="hero__link" v-if="linkToDept">
      <div class="hero__link__dot"></div>
      <split-text :dur="1" :stay="true">
        <a slot-scope="{}" href="//deptagency.com">Sorthvid is now Dept</a>
      </split-text>
      <svg x="0px" y="0px" viewBox="150 410 300 70" xml:space="preserve">
        <polygon
          class="st0"
          points="435.7,445.5 406.8,416.6 406.8,442.3 162.8,442.3 162.8,448.8 406.8,448.8 406.8,474.5 "
        />
      </svg>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import SplitText from "@/components/split-text";

export default {
  name: "Hero",
  components: { SplitText },
  props: {
    msg: { type: String, default: "" },
    fullpage: { type: Boolean, defalut: false },
    linkToDept: { type: Boolean, defalut: false }
  },
  computed: mapState({
    opacity: state => {
      const percentOfVh = state.globals.currentScroll / window.innerHeight;
      return Math.max(1 - percentOfVh * 2, 0);
    }
  })
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

@keyframes size {
  to {
    transform: scale(1.5);
  }
}
@keyframes opacity {
  to {
    opacity: 0;
  }
}

@keyframes dotFade {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.hero {
  position: relative;
  top: 0;
  width: 100%;
  box-sizing: border-box;
  @extend %page-margin-1;
  @extend %page-margin-3-v;
  padding-top: $margin1-1;

  @media screen and (min-width: 769px) {
    padding-top: $margin2-1;
  }

  &.fullpage {
    height: 80vh;
  }

  h1 {
    @include typeface(expanded);
    @include typeset(hero);

    opacity: 0;
    max-width: 26em;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    margin: 2em 0;
    cursor: pointer;

    &:hover {
      a {
        &:after {
          opacity: 1;
        }
      }

      .hero__link__dot {
        &:before {
          background-color: $color-black;
        }
      }
    }

    a {
      @include typeface(expanded);
      @include typeset(body-large);
      display: inline-flex;
      align-items: center;

      &:after {
        transition: opacity 0.6s cubic-bezier(0.86, 0, 0.07, 1);
        opacity: 0;
        content: "";
        position: fixed;
        background: $color-dept;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: -1;
        pointer-events: none;
      }
    }

    &__dot {
      opacity: 0;
      transform: translateY(5px);
      animation: dotFade 1s 0.6s forwards;
      width: 2em;
      height: 2em;
      display: inline-flex;
      align-items: center;

      &:before {
        transition: background-color 0.6s cubic-bezier(0.86, 0, 0.07, 1);
        animation: size 1.6s ease-in infinite alternate;
        content: "";
        width: 0.8em;
        height: 0.8em;
        border-radius: 2em;
        background: $color-dept;
        margin-right: 1em;
      }

      &:after {
        animation: opacity 1.6s ease-in-out infinite alternate-reverse;
        position: absolute;
        content: "";
        width: 2em;
        height: 2em;
        border-radius: 2em;
        margin-left: -0.5em;
        backdrop-filter: blur(2px);
      }
    }

    svg {
      opacity: 0;
      transform: translateY(5px);
      animation: dotFade 1s 0.6s forwards;
      padding-left: 18px;
      fill: white;
      height: 1rem;
    }
  }
}
</style>
